import type { CarEventType } from './types.ts'

export const CAR_EXPENSE_CODE = 'EXPENSE.CAR'

/** The seeded `EXPENSE.CAR` leaves and the event each records; `EXPENSE.CAR.OTHER` has none. */
const EVENT_TYPE_BY_ACCOUNT_CODE: Readonly<Record<string, CarEventType>> = {
  'EXPENSE.CAR.FUEL': 'FUEL',
  'EXPENSE.CAR.SERVICE': 'REPAIR',
  'EXPENSE.CAR.INSURANCE': 'INSURANCE_PAYMENT',
  'EXPENSE.CAR.TAX': 'TAX',
  'EXPENSE.CAR.INSPECTION': 'INSPECTION',
  'EXPENSE.CAR.REGISTRATION': 'REGISTRATION',
  'EXPENSE.CAR.CAR_WASH': 'CAR_WASH',
  'EXPENSE.CAR.PARKING': 'PARKING',
  'EXPENSE.CAR.FINE': 'FINE',
  'EXPENSE.CAR.TIRES': 'TIRE_CHANGE',
}

export interface CarCost {
  /** Undefined when the account does not decide it, and the type is asked. */
  readonly type: CarEventType | undefined
}

/** A category under `EXPENSE.CAR`, at any depth; its type follows the seeded leaf it sits under. */
export function carCostFor(codePath: readonly string[]): CarCost | undefined {
  const root = codePath.indexOf(CAR_EXPENSE_CODE)
  if (root === -1 || root === codePath.length - 1) return undefined
  return { type: EVENT_TYPE_BY_ACCOUNT_CODE[codePath[root + 1]!] }
}

export function carAccountCodeFor(type: CarEventType): string | undefined {
  return Object.entries(EVENT_TYPE_BY_ACCOUNT_CODE).find(([, mapped]) => mapped === type)?.[0]
}
